/* Zypher v134 smart video-game search */
window.ZypherSmartSearch = (() => {
  const exactSystems = [
    { key:'ps5', display:'PS5', pattern:/\b(?:ps\s*5|playstation\s*5)\b/i, clause:'tag:"PlayStation 5"', family:'playstation' },
    { key:'ps4', display:'PS4', pattern:/\b(?:ps\s*4|playstation\s*4)\b/i, clause:'tag:"PlayStation 4"', family:'playstation' },
    { key:'ps3', display:'PS3', pattern:/\b(?:ps\s*3|playstation\s*3)\b/i, clause:'tag:"PlayStation 3"', family:'playstation' },
    { key:'ps2', display:'PS2', pattern:/\b(?:ps\s*2|playstation\s*2)\b/i, clause:'tag:"PlayStation 2"', family:'playstation' },
    { key:'ps1', display:'PS1', pattern:/\b(?:ps\s*1|psx|playstation\s*1)\b/i, clause:'tag:"PlayStation 1"', family:'playstation' },
    { key:'psp', display:'PSP', pattern:/\bpsp\b/i, clause:'tag:"PSP"', family:'playstation' },
    { key:'vita', display:'PS Vita', pattern:/\b(?:ps\s*vita|vita)\b/i, clause:'tag:"PS Vita"', family:'playstation' },

    { key:'xbox360', display:'Xbox 360', pattern:/\bxbox\s*360\b/i, clause:'tag:"Xbox 360"', family:'xbox' },
    { key:'xboxone', display:'Xbox One', pattern:/\bxbox\s*one\b/i, clause:'tag:"Xbox One"', family:'xbox' },
    { key:'xboxseries', display:'Xbox Series X/S', pattern:/\bxbox\s*series(?:\s*[xs])?(?:\s*\/\s*s)?\b/i, clause:'tag:"Xbox Series X/S"', family:'xbox' },
    { key:'xboxoriginal', display:'Original Xbox', pattern:/\b(?:original\s*xbox|xbox\s*original)\b/i, clause:'tag:"Xbox Original"', family:'xbox' },

    { key:'switch', display:'Switch', pattern:/\b(?:nintendo\s*)?switch\b/i, clause:'tag:"Nintendo Switch"', family:'nintendo' },
    { key:'wiiu', display:'Wii U', pattern:/\b(?:nintendo\s*)?wii\s*u\b/i, clause:'tag:"Nintendo Wii U"', family:'nintendo' },
    { key:'wii', display:'Wii', pattern:/\b(?:nintendo\s*)?wii\b/i, clause:'tag:"Nintendo Wii"', family:'nintendo' },
    { key:'gamecube', display:'GameCube', pattern:/\b(?:nintendo\s*)?game\s*cube\b/i, clause:'tag:"Nintendo GameCube"', family:'nintendo' },
    { key:'n64', display:'N64', pattern:/\b(?:nintendo\s*64|n64)\b/i, clause:'tag:"Nintendo 64"', family:'nintendo' },
    { key:'gba', display:'GBA', pattern:/\b(?:game\s*boy\s*advance|gba)\b/i, clause:'tag:"Nintendo Game Boy Advance"', family:'nintendo' },
    { key:'gameboy', display:'Game Boy', pattern:/\bgame\s*boy(?:\s*color)?\b/i, clause:'tag:"Nintendo Game Boy"', family:'nintendo' },
    { key:'3ds', display:'3DS', pattern:/\b(?:nintendo\s*)?3ds\b/i, clause:'tag:"Nintendo 3DS"', family:'nintendo' },
    { key:'ds', display:'DS', pattern:/\b(?:nintendo\s*)?(?:ds|dsi)\b/i, clause:'tag:"Nintendo DS"', family:'nintendo' },
    { key:'snes', display:'SNES', pattern:/\b(?:super\s*nintendo|snes)\b/i, clause:'tag:"Nintendo SNES"', family:'nintendo' },
    { key:'nes', display:'NES', pattern:/\b(?:nintendo\s*entertainment\s*system|nes)\b/i, clause:'tag:"Nintendo NES"', family:'nintendo' },

    { key:'dreamcast', display:'Dreamcast', pattern:/\b(?:sega\s*)?dreamcast\b/i, clause:'tag:"SEGA Dreamcast"', family:'sega' },
    { key:'genesis', display:'Genesis', pattern:/\b(?:sega\s*)?genesis\b/i, clause:'tag:"SEGA Genesis"', family:'sega' },
    { key:'saturn', display:'Saturn', pattern:/\b(?:sega\s*)?saturn\b/i, clause:'tag:"SEGA Saturn"', family:'sega' },
    { key:'gamegear', display:'Game Gear', pattern:/\b(?:sega\s*)?game\s*gear\b/i, clause:'tag:"SEGA Game Gear"', family:'sega' },
    { key:'segacd', display:'SEGA CD', pattern:/\bsega\s*cd\b/i, clause:'tag:"SEGA CD"', family:'sega' },
    { key:'32x', display:'SEGA 32X', pattern:/\b(?:sega\s*)?32x\b/i, clause:'tag:"SEGA 32X"', family:'sega' },

    { key:'atari2600', display:'Atari 2600', pattern:/\batari\s*2600\b/i, clause:'tag:"ATARI 2600"', family:'atari' },
    { key:'atari5200', display:'Atari 5200', pattern:/\batari\s*5200\b/i, clause:'tag:"ATARI 5200"', family:'atari' },
    { key:'atari7800', display:'Atari 7800', pattern:/\batari\s*7800\b/i, clause:'tag:"ATARI 7800"', family:'atari' },
    { key:'jaguar', display:'Atari Jaguar', pattern:/\b(?:atari\s*)?jaguar\b/i, clause:'tag:"ATARI Jaguar"', family:'atari' }
  ];

  const families = [
    { key:'playstation', display:'PlayStation', pattern:/\bplaystation\b/i, clause:'product_type:"PlayStation Games"', family:'playstation' },
    { key:'xbox', display:'Xbox', pattern:/\bxbox\b/i, clause:'product_type:"Xbox Games"', family:'xbox' },
    { key:'nintendo', display:'Nintendo', pattern:/\bnintendo\b/i, clause:'product_type:"Nintendo Games"', family:'nintendo' },
    { key:'sega', display:'SEGA', pattern:/\bsega\b/i, clause:'product_type:"SEGA Games"', family:'sega' },
    { key:'atari', display:'Atari', pattern:/\batari\b/i, clause:'product_type:"ATARI Games"', family:'atari' }
  ];

  const allSystems = [...exactSystems, ...families];
  const stopWords = new Set(['a','an','the','of','and','or','for','to','vs','versus']);
  const barcodeOrSkuPattern = /^\d{8,14}[a-z]?$/i;
  const escapeValue = value => String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');

  const decodeHtml = value => {
    const node = document.createElement('textarea');
    node.innerHTML = String(value || '');
    return node.value;
  };

  const detectSystem = rawValue => {
    const raw = decodeHtml(rawValue).trim();
    const exact = exactSystems.find(item => item.pattern.test(raw));
    if (exact) return exact;
    return families.find(item => item.pattern.test(raw)) || null;
  };

  const getSystemByKey = key => allSystems.find(item => item.key === key) || null;

  const stripSystem = rawValue => {
    let value = decodeHtml(rawValue).trim();
    const detected = detectSystem(value);
    if (detected) value = value.replace(detected.pattern, ' ');
    return value.replace(/\s+/g, ' ').trim();
  };

  const titleClauses = gamePart => {
    const tokens = String(gamePart || '').split(/\s+/).filter(Boolean);
    const clauses = [];
    let wrestlingSynonymAdded = false;

    tokens.forEach(token => {
      const cleaned = token.replace(/^[^a-z0-9]+|[^a-z0-9]+$/gi, '');
      if (!cleaned) return;
      const lower = cleaned.toLowerCase();
      if (stopWords.has(lower)) return;

      if (lower === 'wwe' || lower === 'wwf') {
        if (!wrestlingSynonymAdded) {
          clauses.push('(title:wwe OR title:wwf)');
          wrestlingSynonymAdded = true;
        }
        return;
      }

      // Shopify tokenizes 2K7 / 2K15 differently from a standalone 2K title filter.
      // Keep mixed letter+number terms loose while the rest remains title-only.
      if (/[a-z]/i.test(cleaned) && /\d/.test(cleaned)) {
        clauses.push(escapeValue(cleaned));
      } else {
        clauses.push(`title:"${escapeValue(cleaned)}"`);
      }
    });

    return clauses;
  };

  const buildQuery = (rawValue, options = {}) => {
    const raw = decodeHtml(rawValue).trim().replace(/\s+/g, ' ');
    if (!raw) return '';
    if (barcodeOrSkuPattern.test(raw.replace(/\s/g, ''))) return raw;

    const forcedSystem = options.systemKey ? getSystemByKey(options.systemKey) : null;
    const detectedSystem = forcedSystem || detectSystem(raw);

    // No system means keep Shopify's typo-tolerant broad search unless a sidebar
    // condition needs to be layered on top.
    if (!detectedSystem) {
      const condition = options.conditionTag ? `tag:"${escapeValue(options.conditionTag)}"` : '';
      return condition ? `${raw} AND ${condition}` : raw;
    }

    const gamePart = stripSystem(raw);
    const clauses = titleClauses(gamePart);
    clauses.push(detectedSystem.clause);

    if (options.conditionTag) {
      clauses.push(`tag:"${escapeValue(options.conditionTag)}"`);
    }

    return clauses.filter(Boolean).join(' AND ');
  };

  const humanizeInternal = rawValue => {
    let value = decodeHtml(rawValue);
    const replacements = [
      [/product_type:"PlayStation Games"/gi,'PlayStation'],
      [/product_type:"Xbox Games"/gi,'Xbox'],
      [/product_type:"Nintendo Games"/gi,'Nintendo'],
      [/product_type:"SEGA Games"/gi,'SEGA'],
      [/product_type:"ATARI Games"/gi,'Atari'],
      [/tag:"PlayStation 5"/gi,'PS5'], [/tag:"PlayStation 4"/gi,'PS4'],
      [/tag:"PlayStation 3"/gi,'PS3'], [/tag:"PlayStation 2"/gi,'PS2'],
      [/tag:"PlayStation 1"/gi,'PS1'], [/tag:"PSP"/gi,'PSP'], [/tag:"PS Vita"/gi,'PS Vita'],
      [/tag:"Xbox 360"/gi,'Xbox 360'], [/tag:"Xbox One"/gi,'Xbox One'],
      [/tag:"Xbox Series X\/S"/gi,'Xbox Series X/S'], [/tag:"Xbox Original"/gi,'Original Xbox'],
      [/tag:"Nintendo Switch"/gi,'Switch'], [/tag:"Nintendo Wii U"/gi,'Wii U'],
      [/tag:"Nintendo Wii"/gi,'Wii'], [/tag:"Nintendo GameCube"/gi,'GameCube'],
      [/tag:"Nintendo 64"/gi,'N64'], [/tag:"Nintendo Game Boy Advance"/gi,'GBA'],
      [/tag:"Nintendo Game Boy"/gi,'Game Boy'], [/tag:"Nintendo 3DS"/gi,'3DS'],
      [/tag:"Nintendo DS"/gi,'DS'], [/tag:"Nintendo SNES"/gi,'SNES'], [/tag:"Nintendo NES"/gi,'NES'],
      [/tag:"SEGA Dreamcast"/gi,'Dreamcast'], [/tag:"SEGA Genesis"/gi,'Genesis'],
      [/tag:"SEGA Saturn"/gi,'Saturn'], [/tag:"SEGA Game Gear"/gi,'Game Gear'],
      [/tag:"SEGA CD"/gi,'SEGA CD'], [/tag:"SEGA 32X"/gi,'SEGA 32X'],
      [/tag:"ATARI 2600"/gi,'Atari 2600'], [/tag:"ATARI 5200"/gi,'Atari 5200'],
      [/tag:"ATARI 7800"/gi,'Atari 7800'], [/tag:"ATARI Jaguar"/gi,'Atari Jaguar']
    ];

    value = value
      .replace(/\(title:wwe\s+OR\s+title:wwf\)/gi,'WWE')
      .replace(/tag:"zypher-instock-[^"]+"/gi,' ');

    replacements.forEach(([pattern, replacement]) => {
      value = value.replace(pattern, replacement);
    });

    return value
      .replace(/title:"([^"]+)"/gi,'$1')
      .replace(/title:([^\s)]+)/gi,'$1')
      .replace(/\bAND\b/gi,' ')
      .replace(/[()]/g,' ')
      .replace(/\s+/g,' ')
      .trim();
  };

  const getDisplayQuery = () => {
    const params = new URLSearchParams(window.location.search);
    const stored = params.get('zypher_query');
    if (stored) return decodeHtml(stored).trim();
    return humanizeInternal(params.get('q') || '');
  };

  const updateDisplay = () => {
    const display = getDisplayQuery();
    if (!display) return;

    document.querySelectorAll('input[type="search"]').forEach(input => {
      if (document.activeElement !== input && input.value !== display) input.value = display;
    });

    const crumb = document.querySelector('.breadcrumb_title');
    if (crumb) {
      const match = crumb.textContent.match(/Search:\s*([\d,]+)\s+results?/i);
      const count = match ? match[1] : null;
      if (count) {
        const title = `Search: ${count} results found for "${display}"`;
        if (crumb.textContent !== title) crumb.textContent = title;
      }
    }
  };

  const ensureHidden = (form, name, value) => {
    if (!form || !value) return;
    let input = form.querySelector(`input[type="hidden"][name="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  };

  const syncFacetForms = () => {
    const params = new URLSearchParams(window.location.search);
    const display = getDisplayQuery();
    document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile, #FacetSortForm').forEach(form => {
      if (display) ensureHidden(form, 'zypher_query', display);
      ['zypher_system','zypher_condition'].forEach(name => {
        const value = params.get(name);
        if (value) ensureHidden(form, name, value);
      });
    });
  };

  const syncFilterState = () => {
    const params = new URLSearchParams(window.location.search);
    const display = getDisplayQuery();
    const detected = detectSystem(display);
    const activeSystem = params.get('zypher_system') || detected?.key || '';
    const activeCondition = params.get('zypher_condition') || '';
    const availability = params.get('filter.v.availability') || '';

    document.querySelectorAll('[data-zypher-search-system]').forEach(link => {
      const active = link.dataset.zypherSearchSystem === activeSystem;
      if (active) link.setAttribute('aria-current','page');
      else link.removeAttribute('aria-current');
    });

    document.querySelectorAll('[data-zypher-search-condition]').forEach(link => {
      const active = link.dataset.zypherSearchCondition === activeCondition;
      if (active) link.setAttribute('aria-current','page');
      else link.removeAttribute('aria-current');
    });

    document.querySelectorAll('[data-zypher-search-availability]').forEach(link => {
      const target = link.dataset.zypherSearchAvailability;
      const active = (target === 'available' && availability === '1') ||
                     (target === 'out-of-stock' && availability === '0');
      if (active) link.setAttribute('aria-current','page');
      else link.removeAttribute('aria-current');
    });

    if (activeSystem) {
      const system = getSystemByKey(activeSystem);
      if (system) {
        document.querySelectorAll(`details[data-zypher-family="${system.family}"]`).forEach(details => {
          details.open = true;
        });
      }
    }
  };

  const navigateWithFilters = options => {
    const params = new URLSearchParams(window.location.search);
    let display = getDisplayQuery();
    let systemKey = options.systemKey ?? params.get('zypher_system') ?? detectSystem(display)?.key ?? '';
    let conditionTag = options.conditionTag ?? params.get('zypher_condition') ?? '';

    if (options.systemKey !== undefined) {
      const currentSystem = detectSystem(display);
      const nextSystem = getSystemByKey(options.systemKey);
      display = stripSystem(display);
      if (nextSystem) display = `${display} ${nextSystem.display}`.trim();
      systemKey = nextSystem?.key || '';
    }

    if (options.conditionTag !== undefined) {
      conditionTag = options.conditionTag || '';
    }

    const internal = buildQuery(display, { systemKey, conditionTag });
    params.set('q', internal);
    params.set('zypher_query', display);
    params.set('type','product');
    params.set('options[unavailable_products]','show');
    params.set('options[prefix]','last');
    params.set('sort_by','relevance');

    if (systemKey) params.set('zypher_system', systemKey);
    else params.delete('zypher_system');

    if (conditionTag) params.set('zypher_condition', conditionTag);
    else params.delete('zypher_condition');

    if (options.availability !== undefined) {
      if (options.availability === 'available') params.set('filter.v.availability','1');
      else if (options.availability === 'out-of-stock') params.set('filter.v.availability','0');
      else params.delete('filter.v.availability');
    }

    window.location.assign(`${window.location.pathname}?${params.toString()}`);
  };

  const bindFilterLinks = () => {
    document.querySelectorAll('[data-zypher-search-system]').forEach(link => {
      if (link.dataset.zypherBound) return;
      link.dataset.zypherBound = 'true';
      link.addEventListener('click', event => {
        event.preventDefault();
        const key = link.dataset.zypherSearchSystem || '';
        const params = new URLSearchParams(window.location.search);
        const active = params.get('zypher_system') || detectSystem(getDisplayQuery())?.key || '';
        navigateWithFilters({ systemKey: active === key ? '' : key });
      });
    });

    document.querySelectorAll('[data-zypher-search-condition]').forEach(link => {
      if (link.dataset.zypherBound) return;
      link.dataset.zypherBound = 'true';
      link.addEventListener('click', event => {
        event.preventDefault();
        const tag = link.dataset.zypherSearchCondition || '';
        const params = new URLSearchParams(window.location.search);
        const active = params.get('zypher_condition') || '';
        navigateWithFilters({ conditionTag: active === tag ? '' : tag });
      });
    });

    document.querySelectorAll('[data-zypher-search-availability]').forEach(link => {
      if (link.dataset.zypherBound) return;
      link.dataset.zypherBound = 'true';
      link.addEventListener('click', event => {
        event.preventDefault();
        const target = link.dataset.zypherSearchAvailability || '';
        const params = new URLSearchParams(window.location.search);
        const current = params.get('filter.v.availability') || '';
        const isCurrent = (target === 'available' && current === '1') ||
                          (target === 'out-of-stock' && current === '0');
        navigateWithFilters({ availability: isCurrent ? '' : target });
      });
    });
  };

  const initForms = () => {
    document.querySelectorAll('form[role="search"]').forEach(form => {
      const input = form.querySelector('input[type="search"]');
      if (!input || form.dataset.zypherSmartSearchReady === 'true') return;
      form.dataset.zypherSmartSearchReady = 'true';
      form.addEventListener('formdata', event => {
        const raw = String(input.value || '').trim();
        const detected = detectSystem(raw);
        event.formData.set('q', buildQuery(raw));
        event.formData.set('zypher_query', raw);
        event.formData.set('type','product');
        event.formData.set('options[unavailable_products]','show');
        event.formData.set('options[prefix]','last');
        if (detected) event.formData.set('zypher_system', detected.key);
        else event.formData.delete('zypher_system');
        event.formData.delete('zypher_condition');
      });
    });
  };

  const init = () => {
    initForms();
    updateDisplay();
    syncFacetForms();
    bindFilterLinks();
    syncFilterState();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once:true });
  } else {
    init();
  }

  let refreshQueued = false;
  const refreshSelector = 'form[role="search"], input[type="search"], .breadcrumb_title, #FacetFiltersForm, #FacetFiltersFormMobile, #FacetSortForm, [data-zypher-search-system], [data-zypher-search-condition], [data-zypher-search-availability], details[data-zypher-family]';
  const observer = new MutationObserver(records => {
    const relevant = records.some(record => {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (target?.closest('.breadcrumb_title, #FacetFiltersForm, #FacetFiltersFormMobile, #FacetSortForm')) return true;
      return Array.from(record.addedNodes).some(node => node.nodeType === 1 &&
        (node.matches(refreshSelector) || node.querySelector(refreshSelector)));
    });
    if (!relevant) return;
    if (refreshQueued) return;
    refreshQueued = true;
    requestAnimationFrame(() => {
      refreshQueued = false;
      init();
    });
  });
  observer.observe(document.documentElement, { childList:true, subtree:true });

  return { buildQuery, detectSystem, getDisplayQuery, init };
})();

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances =
      document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || (this.getQuery() === this.searchTerm && this.querySelector('[aria-selected="true"] a'))) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      "[data-predictive-search-search-for-text]"
    );
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      const literalPreviousTerm = previousTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      if ((currentButtonText.match(new RegExp(literalPreviousTerm, "g")) || []).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(
      this.querySelectorAll("li, button.predictive-search__item")
    ).filter((element) => element.offsetParent !== null);
    if (!allVisibleElements.length) return;
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    if (this.statusElement) this.statusElement.textContent = "";

    if (!moveUp && selectedElement) {
      activeElementIndex =
        selectedElementIndex === allVisibleElements.length - 1
          ? 0
          : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex =
        selectedElementIndex === 0
          ? allVisibleElements.length - 1
          : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    if (this.getQuery() !== this.searchTerm) return;
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );

    if (selectedOption) selectedOption.click();
  }


  getSearchResults(searchTerm) {
    this.abortController.abort();
    const requestController = this.abortController = new AbortController();
    const isCurrentRequest = () => this.abortController === requestController &&
      !requestController.signal.aborted && this.getQuery() === searchTerm;
    const requestTerm = window.ZypherSmartSearch ? window.ZypherSmartSearch.buildQuery(searchTerm) : searchTerm;
    const queryKey = JSON.stringify([requestTerm, window.Shopify?.locale || document.documentElement.lang || 'en']);
    const selected = this.querySelector('[aria-selected="true"]');
    if (selected) selected.setAttribute('aria-selected', 'false');
    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('results');
    this.setLiveRegionLoadingState();

    if (Object.prototype.hasOwnProperty.call(this.cachedResults, queryKey)) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return Promise.resolve();
    }

    const timeout = window.setTimeout(() => {
      if (!isCurrentRequest()) return;
      requestController.abort();
      this.renderSearchFailure();
    }, 12000);
    requestController.signal.addEventListener('abort', () => window.clearTimeout(timeout), { once: true });

    return fetch(
      `${routes.search_url || '/search'}?q=${encodeURIComponent(requestTerm)}&type=product&options%5Bunavailable_products%5D=show&options%5Bprefix%5D=last&section_id=zypher-search-preview`,
      { signal: requestController.signal, credentials: 'same-origin' }
    )
      .then((response) => {
        if (!isCurrentRequest()) return null;
        if (!response.ok) throw new Error(`Search request failed with ${response.status}`);
        return response.text();
      })
      .then((markup) => {
        if (markup === null || !isCurrentRequest()) return;
        const parsed = new DOMParser().parseFromString(markup, 'text/html');
        const previewSection = parsed.querySelector('#shopify-section-zypher-search-preview');
        if (!previewSection?.querySelector('#predictive-search-results') ||
            !previewSection.querySelector('[data-predictive-search-live-region-count-value]')) {
          throw new Error('Search preview markup is incomplete');
        }
        const resultsMarkup = previewSection.innerHTML;
        this.allPredictiveSearchInstances.forEach((instance) => {
          instance.cachedResults = instance.cachedResults || {};
          delete instance.cachedResults[queryKey];
          instance.cachedResults[queryKey] = resultsMarkup;
          Object.keys(instance.cachedResults).slice(0, -20).forEach((key) => delete instance.cachedResults[key]);
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch(() => {
        if (isCurrentRequest()) this.renderSearchFailure();
      })
      .finally(() => window.clearTimeout(timeout));
  }

  renderSearchFailure() {
    const messages = window.zypherSearchStrings || {};
    const wrapper = document.createElement('div');
    wrapper.id = 'predictive-search-results';
    wrapper.setAttribute('role', 'listbox');
    const message = document.createElement('p');
    message.className = 'predictive-search__heading text-body';
    message.setAttribute('role', 'status');
    message.textContent = messages.unavailable || 'Search suggestions are unavailable. View all results to keep searching.';
    const button = document.createElement('button');
    button.type = 'submit';
    button.id = `predictive-search-fallback-${this.input.id || 'search'}`;
    button.className = 'predictive-search__item predictive-search__item--term z175-view-all-results link link--text h5';
    button.setAttribute('role', 'option');
    button.setAttribute('aria-selected', 'false');
    button.textContent = messages.viewAll || 'View all results';
    wrapper.append(message, button);
    this.predictiveSearchResults.replaceChildren(wrapper);
    this.setAttribute('results', 'false');
    this.removeAttribute('loading');
    this.setLiveRegionText(message.textContent);
    this.open();
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    if (!this.statusElement) return;
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]')?.textContent || '');
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - (document.querySelector('.section-header')?.getBoundingClientRect().bottom || 0);
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.abortController.abort();
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);

